import styled from "styled-components";
import logoTMmobile from "../../../assets/logo-TM-mobile.svg";

export const Container = styled.div`
	margin-bottom: 2.5rem;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
`;

export const Logo = styled.div`
	height: 36px;
	width: 168px;

	background: url(${logoTMmobile}) center no-repeat;
	background-size: 168px;
`;

export const Title = styled.label`
	color: var(--neutral-smoothest, #fff);
	font-family: var(--font-family-metropolis-regular);
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%;
	text-align: left;
`;

export const Description = styled.p`
	color: var(--neutral-smooth, #caced4);
	font-family: var(--font-family-metropolis-regular);
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;

	padding: 16px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);

	svg {
		min-width: 24px;
		color: #01e59b;
	}
`;

export const Pros = styled.span`
	color: var(--neutral-smoothest, #fff);
	font-family: var(--font-family-metropolis-regular);
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 170%;
`;

export const Button = styled.button`
	color: var(--neutral-strongest);
	background-color: var(--brand-primary);
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: var(--font-size-default);
	font-weight: 600;
	line-height: 150%;

	padding: 8px 16px;
	border-radius: 8px;

	border: none;
	text-decoration: none;

	&:focus {
		outline: none !important;
	}

	@media only screen and (max-width: 800px) {
		width: 100%;
	}
`;

export const Footer = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`;
